import { gql } from '@apollo/client';

const VIEW_TUTORIAL_LATER_MUTATION = gql`
  mutation viewTutorialLater($viewLater: Boolean!) {
    viewTutorialLater(viewLater: $viewLater) {
      isSuccess
      message
    }
  }
`;

export default VIEW_TUTORIAL_LATER_MUTATION;
